const FOOT_LINKS = [
  { href: '#boundary', label: '尺度边界' },
  { href: '#cases', label: '违规案例' },
  { href: '#reasons', label: '下架原因' },
  { href: '#checklist', label: '发布自查' },
  { href: '#faq', label: '审核问答' },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div className="max-w-md">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-scales-3-line text-lg" />
              </span>
              <span className="font-serif text-lg font-black text-foreground-950">
                51擦边
                <i className="ri-arrow-right-up-line ml-1 text-primary-500" />
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              本站是一份「内容审核规则」专题合集：把 51擦边审核标准、尺度边界、违规案例与下架原因整理成可检索的参考，
              帮你在发布前看清雷区，在吃瓜时读懂一条内容为何突然消失。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['审核标准', '尺度边界', '违规案例', '下架原因'].map((k) => (
                <span key={k} className="rounded-full bg-background-200 px-3 py-1 text-xs font-semibold text-foreground-700">
                  {k}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">内容栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {FOOT_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="inline-flex items-center gap-2 text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    <i className="ri-arrow-right-line text-primary-400 text-xs" />
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">阅读约定</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              本专题中的判定维度、处置阶梯与案例均为规则解读与场景梳理，系本站编辑整理，不构成任何平台官方审核口径。
            </p>
            <a href="#top" className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600">
              回到顶部
              <i className="ri-arrow-up-line text-sm" />
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">© {new Date().getFullYear()} 51擦边 · 规则解读专题，仅供参考。</p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-scales-3-line text-primary-500" />
            把尺度边界看清楚，才能真守住。
          </p>
        </div>
      </div>
    </footer>
  );
}